export const numberToString = (value: number) => {
    return (Math.round(value * 100) / 100).toString().replace(".", ",");
};

export const stringToNumber = (value: string) => {
    return parseFloat(value.replace(",", "."));
};
